/**
 * Query key factory for candidate report data hooks. Used for cache consistency and invalidation.
 */

export const candidatesQueryKeys = {
  all: ["candidates"] as const,

  /** GET /api/v2/Candidates (paginated list, applies grouped by candidate). */
  list: (params: Record<string, unknown>) =>
    [...candidatesQueryKeys.all, "list", params] as const,

  /** GET /api/v2/Candidates/Metrics/Aggregated (aggregated metrics). */
  metrics: (params: Record<string, unknown>) =>
    [...candidatesQueryKeys.all, "metrics", params] as const,

  /** GET /api/v2/Candidates/FilterCounts (drawer options, counted in candidates). */
  filterCounts: (params: Record<string, unknown>) =>
    [...candidatesQueryKeys.all, "filterCounts", params] as const,

  /** GET /api/v2/Candidates/FilterCounts/{dimension} (one dimension, paged on scroll). */
  filterOptions: (dimension: string, params: Record<string, unknown>) =>
    [...candidatesQueryKeys.all, "filterOptions", dimension, params] as const,
};
